import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Box, Card, DataLegend, InternalGrid } from '@paygreen/paygreen-ui';
import { IsDesktop } from '../../../utils/tools';
import CarbonEquivalencePopin from './shared/CarbonEquivalencePopin';

const DashboardCardTotalCo2 = ({ t, carbonData, hasDataLegend }) => {
    const { convertedValue, convertedUnit } = carbonData;

    return (
        <Card
            colorPallet="status"
            shadowSize="none"
            blockWidth={IsDesktop() ? 'md' : 'none'}
            paddingLateral="xs"
            paddingBottom={hasDataLegend ? 'sm' : 'xs'}
            paddingTop={hasDataLegend ? 'sm' : 'xs'}
            radiusSize="sm"
            style={
                !convertedValue
                    ? { filter: 'grayscale(1)', opacity: '0.85' }
                    : null
            }
        >
            <InternalGrid
                style={{ height: '100%' }}
                displayType="grid"
                gridTemplateColumns="1fr"
                alignItems="stretch"
                justifyItems={IsDesktop() ? 'start' : 'center'}
            >
                {hasDataLegend && (
                    <DataLegend
                        value={convertedValue || 0}
                        unit={t(`carbonUnits.${convertedUnit}`, {
                            count: convertedValue,
                        })}
                        colorPallet="status"
                    />
                )}

                <Box marginTop={hasDataLegend ? 'md' : 'none'}>
                    <CarbonEquivalencePopin
                        iconStyle={{
                            iconSize: 'md',
                            colorPallet: 'status',
                            colorStatus: 'default',
                        }}
                        carbonValue={convertedValue}
                        unit={convertedUnit}
                        position="center"
                        hasPopin={false}
                        hasDataLegend={hasDataLegend}
                    />
                </Box>
            </InternalGrid>
        </Card>
    );
};

DashboardCardTotalCo2.propTypes = {
    carbonData: PropTypes.object.isRequired,
    hasDataLegend: PropTypes.bool,
};

DashboardCardTotalCo2.defaultProps = {
    hasDataLegend: true,
};

export default withTranslation('common')(DashboardCardTotalCo2);
